import amplitude from 'amplitude-js';

import env from './env';

let amplitudeInstance: amplitude.AmplitudeClient;

if (typeof window !== 'undefined') {
  amplitude.getInstance().init(env.AMPLITUDE_API_KEY, undefined, {
    includeReferrer: true,
    includeUtm: true,
    includeGclid: true,
    includeFbclid: true
  });

  amplitudeInstance = amplitude.getInstance();
}

export { amplitudeInstance };
